import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=468a9ddf"
import script from "./addModal.vue?vue&type=script&lang=js"
export * from "./addModal.vue?vue&type=script&lang=js"
import style0 from "./addModal.vue?vue&type=style&index=0&id=468a9ddf&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('468a9ddf')) {
      api.createRecord('468a9ddf', component.options)
    } else {
      api.reload('468a9ddf', component.options)
    }
    module.hot.accept("./addModal.vue?vue&type=template&id=468a9ddf", function () {
      api.rerender('468a9ddf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/typeManage/addModal.vue"
export default component.exports